import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { HttpApiClient } from "../../axios/axiosInstance";
import {
  fetchTestimonials,
  getMyProfile,
  onboardArtist,
  uploadPhotoMediaService,
} from "../../services";

const initialState = {
  testimonials: [],
  testimonialsError: null,
  testimonialsLoading: false,
  artistProfile: [],
  profileLoading: false,
  profileError: null,
  userOnboarded: false,
  upsertError: false
};

export const fetchArtistTestimonials = createAsyncThunk(
  "artistProfile/fetchArtistTestimonials",
  async (request) => {
    const response = await HttpApiClient.post(fetchTestimonials, request);

    return response.data;
  }
);

export const upsertProfile = createAsyncThunk(
  "artistProfile/upsertProfile",
  async (request) => {
    const response = await HttpApiClient.post(onboardArtist, request);
    return response?.data;
  }
);

export const getProfile = createAsyncThunk(
  "artistProfile/getProfile",
  async (request) => {
    const response = await HttpApiClient.get(getMyProfile);
    return response?.data?.data;
  }
);

export const uploadProfilePhotoMedia = createAsyncThunk(
  "artistProfile/uploadProfilePhotoMedia",
  async (request) => {
    const response = await HttpApiClient.post(uploadPhotoMediaService, request);
    return response.data;
  }
);

const artistProfileSlice = createSlice({
  name: "artistProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArtistTestimonials.pending, (state) => {
        state.testimonialsLoading = true;
        state.error = null;
      })
      .addCase(fetchArtistTestimonials.fulfilled, (state, action) => {
        state.testimonialsLoading = false;
        state.testimonials = action.payload.data;
      })
      .addCase(fetchArtistTestimonials.rejected, (state, action) => {
        state.testimonialsLoading = false;
        state.testimonialsError = action.error.message;
      })
      .addCase(upsertProfile.pending, (state) => {
        state.upsertError = false
      })
      .addCase(upsertProfile.fulfilled, (state, action) => {
        state.userOnboarded = true;
        state.upsertError = false
      })
      .addCase(upsertProfile.rejected, (state, action) => {
        state.upsertError = true
      })

      .addCase(getProfile.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.artistProfile = action.payload;
        state.profileLoading = false;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.profileLoading = false;
      });
  },
});

export default artistProfileSlice.reducer;
